//MODULE IMPORTS
import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import elementLocale from 'element-ui/lib/locale';
import ElementUI from 'element-ui';
import VeeValidate from 'vee-validate';
import VueTyperPlugin from 'vue-typer';
import VModal from 'vue-js-modal';
window.axios = require('axios').default;

//LOCAL IMPORTS
import App from './App.vue';
import router from './router/router';
import store from './store';
import i18n from './i18n';
import Parse from './parse-init';
import './sentry-init';
import GENERAL from './config/general';
import ROUTENAMES from './config/navigation/route-names';

//CSS IMPORTS
import './styles/custom.scss';

let locale = 'en';
let user = Parse.User.current();

let userLang = navigator.language || navigator.userLanguage;
userLang = userLang.split('-')[0].toLowerCase();

if (user && user.get('language')) {
  locale = user.get('language');
} else {
  if (userLang && ['de', 'en'].includes(userLang)) locale = userLang;
}

const elementLang = require(`element-ui/lib/locale/lang/${locale}`);
elementLocale.use(elementLang);
i18n.locale = locale;

Vue.prototype.$locale = locale;
Vue.prototype.$clientUrl = GENERAL.clientUrl[process.env.NODE_ENV];
Vue.prototype.$parse = Parse;
Vue.prototype.$routeNames = ROUTENAMES;

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(ElementUI);
Vue.use(VueTyperPlugin);
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: false }, injectModalsContainer: true });
Vue.use(VeeValidate, {
  locale: locale,
  errorBagName: '$errors',
  fieldsBagName: '$fields',
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
